import Layers from "slotworks/graphics/layers/layers";
import autoplayModel from "slotworks/model/autoplay/autoplay-model";
import AbstractSliderControl from "slotworks/smart-ui/controls/abstract/abstract-slider-control";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import { formatMoneyAsCurrency } from "slotworks/utils/string-formatters";

export default class TotalLossLimitSliderControl extends AbstractSliderControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.formatFunction = formatMoneyAsCurrency;
        this.sliderComponent.onChange.add(this.onChangeHandler);
        this.sliderComponent.onInput.add(this.onChangeHandler);
    }

    public updateOptions(options: ControlOptions) {
        super.updateOptions(options);

        if (this.lossLimitRequiredIsNotNeeded() && !options.lossLimit.values.length) {
            this.setVisibleLossLimit(false);
        }

        if (options.lossLimit.values.length > 0 &&
            options.lossLimit.values[0] !== 0) {
                options.lossLimit.values.unshift(0);
        }

        this.setupData(options.lossLimit.values, options.lossLimit.currentValue);
    }

    protected onChangeHandler = (value: number) => {

        const options = new ControlOptions();
        options.lossLimit = this.options.lossLimit.clone();
        options.lossLimit.setCurrentIndex(value);

        if (options.lossLimit.currentValue > 0) {
            options.flashLossLimit = false;
        }

        this.setValueLabel(options.lossLimit.currentValue);

        this.onChange.dispatch(options);
    }

    private setVisibleLossLimit(visible: boolean) {
        this.setVisible(visible);
        this.setVisibleValue(visible);
    }

    private lossLimitRequiredIsNotNeeded() {
        return !autoplayModel.lossLimitRequired;
    }
}
